import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      /* Row spacing is carried by each row's own padding; zeroing the
         shared gap keeps the padding tracks exact too. */
      --block-row-gap: 0px;
    }

    /*
      Mobile: the text stacks above the media, each full width. All vertical
      rhythm is explicit rows and margins, so the grid's row gap is dropped.
    */
    .cory-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        calc(50rem / var(--default-rem-px-count))
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
      width: 100%;
    }

    .details {
      grid-column: 2 / 8;
      grid-row: 2;

      display: flex;
      flex-direction: column;
    }

    .details.vertical-center {
      align-self: center;
    }

    .text-block {
      display: flex;
      flex-direction: column;
      gap: calc(30rem / var(--default-rem-px-count));
    }

    /* The CTA sits further from the text than the download links do. */
    .details > *:not(:first-child) {
      margin-top: calc(40rem / var(--default-rem-px-count));
    }

    .details > .downloads-wrapper {
      display: flex;
      flex-direction: column;
      gap: calc(8rem / var(--default-rem-px-count));
      margin-top: calc(30rem / var(--default-rem-px-count));
    }

    .image,
    .video,
    .spinshot {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    .spinshot {
      width: 100%;
      height: auto;
      aspect-ratio: 4 / 3;
    }

    .image img {
      max-width: 100%;
    }

    .video {
      width: 100%;
      position: relative;
    }

    /* The cluster styles itself; only the offset below the media is ours. */
    .image-description {
      margin-top: calc(14rem / var(--default-rem-px-count));
    }

    @media (min-width: 600px) {
      /* Tablet: text and media split the grid in half on one row. */
      .cory-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .text-block {
        gap: calc(40rem / var(--default-rem-px-count));
      }

      .details > *:not(:first-child) {
        margin-top: calc(80rem / var(--default-rem-px-count));
      }

      .details > .downloads-wrapper {
        margin-top: calc(30rem / var(--default-rem-px-count));
      }

      .image,
      .video,
      .spinshot {
        grid-column: 8 / 14;
        grid-row: 2;
      }

      .cory-layout.mirror .details {
        grid-column: 8 / 14;
      }

      .cory-layout.mirror .image,
      .cory-layout.mirror .video,
      .cory-layout.mirror .spinshot {
        grid-column: 2 / 8;
      }
    }

    @media (min-width: 1024px) {
      /*
        Desktop: text takes four columns and the media seven, with an empty
        column between them. Mirrored, the media leads and the text follows a
        gutter later, ending one column short of the right edge.
      */
      .details {
        grid-column: 2 / 6;
      }

      .image,
      .video,
      .spinshot {
        grid-column: 7 / 14;
      }

      .cory-layout.mirror .details {
        grid-column: 9 / 13;
      }

      .cory-layout.mirror .image,
      .cory-layout.mirror .video,
      .cory-layout.mirror .spinshot {
        grid-column: 2 / 9;
      }

      /*
        A nested seven-column grid over the media, so the caption can sit one
        page column in from each edge of the image. Same track count and
        gutter as the span it covers, so the lines coincide.
      */
      .image {
        display: grid;
        grid-template-columns: repeat(7, minmax(0, 1fr));
        gap: 0 var(--between-column-padding);
      }

      .image img {
        grid-column: 1 / 8;
      }

      .image-description {
        grid-column: 2 / 7;
      }
    }
  `,
];
